import { render, staticRenderFns } from "./alertAnimated.vue?vue&type=template&id=965c96ca"
import script from "./alertAnimated.vue?vue&type=script&lang=js"
export * from "./alertAnimated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports